<script setup>
import { usePage } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'

const page = usePage()
const logoSrc = computed(() => page.props.value.app.logoSrc)
</script>

<template>
  <img
    v-if="logoSrc"
    :src="logoSrc"
    alt="Logo"
    class="block h-full w-40 max-w-full object-contain"
  >
</template>
